
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onvista-cashback/dab",
      function () {
        return require("private-next-pages/onvista-cashback/dab.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onvista-cashback/dab"])
      });
    }
  